var _path, _path2, _rect, _path3, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebVisitorEmailDetector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.999 8H7.111A3.12 3.12 0 004 11.111v18.666a3.12 3.12 0 003.111 3.111h24.888a3.12 3.12 0 003.111-3.111V11.111A3.12 3.12 0 0031.999 8zm0 21.777h-3.111V16.089l-9.333 5.91-9.333-5.91v13.688H7.111V11.111h1.867l10.577 6.533 10.577-6.533H32v18.666z",
    fill: "url(#web-visitor-email-detector_svg__paint0_linear_7477_127980)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.999 8H7.111A3.12 3.12 0 004 11.111v18.666a3.12 3.12 0 003.111 3.111h24.888a3.12 3.12 0 003.111-3.111V11.111A3.12 3.12 0 0031.999 8zm0 21.777h-3.111V16.089l-9.333 5.91-9.333-5.91v13.688H7.111V11.111h1.867l10.577 6.533 10.577-6.533H32v18.666z",
    fill: "url(#web-visitor-email-detector_svg__paint1_linear_7477_127980)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2F54EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.958 36.104a.73.73 0 01-.729.73h-8.75a.73.73 0 01-.729-.73 4.375 4.375 0 014.375-4.375h1.458a4.375 4.375 0 014.375 4.375zm-5.104-10.938a2.916 2.916 0 100 5.833 2.916 2.916 0 000-5.832z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#fff",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "web-visitor-email-detector_svg__paint0_linear_7477_127980",
    x1: 35.731,
    y1: 8.229,
    x2: 11.194,
    y2: 38.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "web-visitor-email-detector_svg__paint1_linear_7477_127980",
    x1: 8.666,
    y1: 28.999,
    x2: 30.579,
    y2: 5.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F75C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D22B24"
  })))));
}

export default __webpack_public_path__ + "./fonts/web-visitor-email-detector.01416f1a00b367f567ad9331a7cca932.svg";
export { SvgWebVisitorEmailDetector as ReactComponent };